module.exports = {
      id: "icons:share-usage",
      viewBox: "0 0 16 14",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#icons:share-usage",
      toString: function () {
        return this.url;
      }
    }